/**
 * A map of signing global modal containers to be rendered by `user_session` package.
 * @type {Object<String>}
 * @see https://github.com/fiverr/user_session_package#external-modal-triggers
 */
export const GLOBAL_MODAL_CONTAINERS = {
    SIGN_IN: 'react-sign-in-modal',
    SIGN_UP: 'react-sign-up-modal'
};
